import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { ServiceLocationService } from '@service/service-location.service';
import { ServiceLocation } from '@models/masters/service-location.model';
@Component({
  selector: 'app-confirmationdialog',
  templateUrl: './confirmationdialog.component.html',
  styleUrls: ['./confirmationdialog.component.sass']
})
export class ConfirmationDialogComponent {
  servicelocation: ServiceLocation;
  apiURL: string;
  userId: number;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    public servicelocationService: ServiceLocationService,
  ) {
    dialogRef.disableClose = true;
    this.servicelocation = data.review;
    this.apiURL = data.apiURL;
    this.userId = data.UserId;
  }
  onOkClick(): void {
    this.dialogRef.close();
  }

}
